var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.101,
    height: 12.881,
    viewBox: "0 0 16.101 12.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-1 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M17.1,5.685A1.977,1.977,0,0,0,15.147,4H3.006a1.977,1.977,0,0,0-1.95,1.685l8.021,5.19Z",
    transform: "translate(-0.026)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M9.342,14.506a.537.537,0,0,1-.583,0L1,9.486v7.957a1.982,1.982,0,0,0,1.98,1.98H15.121a1.982,1.982,0,0,0,1.98-1.98V9.485Z",
    transform: "translate(0 -2.541)",
    fill: "#00b9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.459eaf02fa2ef506d61585d2f48a49fd.svg";
export { ForwardRef as ReactComponent };